import { ConfigurationPage } from '@texas/components/configuration/layout/ConfigurationPage';
import { DataTableContainer } from '@texas/components/shared/dataTable/DataTableContainer';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { customsCodeTableColumns } from './Columns';
import { CustomsCodeFilters } from './CustomsCodeFilters';
import { useCustomsCodes } from './useCustomsCodes';

export function CustomsCodes() {
  const { t } = useTranslation();
  const state = useCustomsCodes();
  const columns = useMemo(() => customsCodeTableColumns(t), [t]);

  return (
    <ConfigurationPage
      title={t('configuration.navigation.customsCodes')}
      description={t('configuration.customsCodesDescription')}
      toolbar={
        <CustomsCodeFilters
          branches={state.branches}
          filter={state.filter}
          branchId={state.branchId}
          includeArchived={state.includeArchived}
          onFilterChange={state.setFilter}
          onBranchChange={state.setBranchId}
          onIncludeArchivedChange={state.setIncludeArchived}
        />
      }
    >
      <DataTableContainer
        showColumnToggle={false}
        error={state.error}
        datatable={{
          data: state.data,
          columns,
          sorted: state.sorted,
          isLoading: state.loading,
          variant: 'entity-directory',
        }}
        pagination={state.pagination}
      />
    </ConfigurationPage>
  );
}
